import { User } from './../../core/models/user.model';
import { UserService } from './../../core/services/user.service';
import { Component, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ListFormBase } from '../../core/helper/ListFormBase';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';
import { A3LEmployeeService } from '../../core/services/a3LEmployee.service';
import { A3LEmployee } from '../../core/models/a3LEmployee.model';
import CustomStore from 'devextreme/data/custom_store';
import { HttpParams } from '@angular/common/http';
import { Utilidades } from '../../core/helper/utilidades';
import { PageList } from '../../core/models/pageList.model';

@Component({
  selector: 'app-usuario-list',
  templateUrl: './usuario-list.component.html',
  styleUrls: ['./usuario-list.component.scss'],
  providers: [UserService, A3LCompanyService, A3LEmployeeService]
})
export class UsuarioListComponent extends ListFormBase<User>
  implements AfterViewInit {

    // Propiedades del panel contenedor
  panelIcon = 'person'; // Material icon
  panelTitle = 'Usuario';
  panelDescription = 'Listado de los usuarios de la aplicación';

  a3LaboralCompany: number;
  a3LaboralCompanies: A3LCompany[];
  a3LaboralEmployees: A3LEmployee[];
  customDataSource: any;

  constructor(
    protected _modelService: UserService,
    protected _a3LCompanyService: A3LCompanyService,
    protected _a3lEmployeeService: A3LEmployeeService,
    protected _router: Router,
    protected _route: ActivatedRoute,
    protected _messageDialog: MessageDialog
  ) {
    super(_modelService, _router, _route, _messageDialog, User);
    this.isCrud = true;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.getDataSource('id');
    });
  }

  // onCreateA3LaboralUser(){
  //   this.getDataSource('id');
  // }

}
